import { UserDetails } from "@/data/repos/commonModels";
import { Connection } from "@/data/repos/connectionList";
import { localeDateFormat, localeDateTimeFormat } from "@/modules/dates";
import moment from "moment/moment";

export interface User {
  id: number | string;
  email: string;
  first_name: string;
  last_name: string;
  type: string;
  phone: string;
  organisation: string;
  position: string;
  directory: string;
  address: string;
  last_activity: string;
  applications: string[];
  active?: boolean;
  expirationTimestamp?: string;
  suspendedDate?: string;
  startDateTime?: string;
  lastLoginDateTime?: string;
  appRoles?: { [key: string]: string };
}

export interface Client {
  id: number;
  key: string;
  parentId?: number;
  parentKey?: string;
  parentName?: string;
  name?: string;
  type?: string;
  logoUrl: string;
  active?: boolean;
  children?: Client[];
}

export interface ClientConfig {
  key: string;
  text: string;
}

export const usersColumns = [
  {
    name: "email",
    label: "Email Address",
    align: "left",
    field: (row: User) => row.email,
    classes: "primary",
    sortable: true,
    filter: false,
    customBodyRender: (row: User) =>
      `<p class="hover:cursor-pointer">${row.email}</p>`,
  },
  {
    name: "first_name",
    label: "First name",
    align: "left",
    showMobile: "top",
    mobilePosition: 2,
    field: (row: User) => row.first_name,
    sortable: true,
  },
  {
    name: "last_name",
    label: "Last Name",
    align: "left",
    showMobile: "top",
    mobilePosition: 1,
    field: (row: User) => row.last_name,
    sortable: true,
  },
  {
    name: "organisation",
    label: "Organisation",
    align: "left",
    showMobile: "bottom",
    mobilePosition: 2,
    field: (row: User) => row.organisation,
    sortable: true,
    type: "select",
    options: [
      { label: "Org A", value: "Org A" },
      { label: "Org B", value: "Org B" },
      { label: "Org C", value: "Org C" },
      { label: "Org D", value: "Org D" },
    ],
  },
  {
    name: "position",
    label: "Position",
    align: "left",
    showMobile: "bottom",
    mobilePosition: 1,
    field: (row: User) => row.position,
    sortable: true,
  },
  {
    name: "directory",
    label: "Directory",
    align: "left",
    field: (row: User) => row.directory,
    sortable: true,
  },
  {
    name: "active",
    label: "Active",
    align: "left",
    field: (row: User) => row.active,
    filter: false,
    customBodyRender: (row: User) =>
      `<input  type="checkbox" ${
        row.active ? "checked" : ""
      } onclick="return false;"/>`,
  },
  {
    name: "suspended",
    label: "Suspended",
    align: "left",
    field: (row: User) => row.suspendedDate,
    filter: false,
    customBodyRender: (row: User) =>
      `<input  type="checkbox" ${
        row.suspendedDate ? "checked" : ""
      } onclick="return false;"/>`,
  },
  {
    name: "expirationTimestamp",
    label: "Expiration",
    align: "left",
    field: (row: User) => row.id,
    filter: false,
    customBodyRender: (row: User) =>
      `${localeDateFormat(row.expirationTimestamp)}`,
  },
  {
    name: "startDateTime",
    label: "Created",
    align: "left",
    field: (row: User) => row.startDateTime,
    sortable: true,
    sort: (a: string, b: string) =>
      moment(a, "DD/MM/YYYY") > moment(b, "DD/MM/YYYY"),
    filter: false,
    customBodyRender: (row: User) => `${localeDateFormat(row.startDateTime)}`,
  },
  {
    name: "lastLoginDateTime",
    label: "Last login",
    align: "left",
    field: (row: User) => row.lastLoginDateTime,
    sortable: true,
    sort: (a: string, b: string) =>
      moment(a, "DD/MM/YYYY HH:mm:ss") > moment(b, "DD/MM/YYYY HH:mm:ss"),
    filter: false,
    customBodyRender: (row: User) =>
      `${localeDateTimeFormat(row.lastLoginDateTime)}`,
  },
];

export const connectionsColumns = [
  {
    name: "userName",
    label: "User name",
    align: "left",
    field: (row: Connection) => row.userName,
    classes: "primary",
    sortable: true,
  },
  {
    name: "clientAddress",
    label: "Address",
    align: "left",
    field: (row: Connection) => row.clientAddress,
    sortable: true,
  },
  {
    name: "lastActiveTs",
    label: "Last Activity",
    align: "left",
    field: (row: Connection) => row.lastActiveTs,
    sortable: true,
  },
  {
    name: "applications",
    label: "Applications",
    align: "left",
    field: (row: Connection) => (row.apps || []).join(", "),
    sortable: true,
  },
];

export function getUserDetailsConst() {
  return {
    id: -1,
    userName: "",
    firstName: "",
    lastName: "",
    position: "",
    organisation: "",
    email: "",
    telephoneNumber: "",
    telephone2Number: "",
    mobileNumber: "",
    extension: "",
    faxNumber: "",
    directory: undefined,
    micadUser: false,
    suspendedDateTime: "",
    expirationTimestamp: "",
    active: true,
  } as UserDetails;
}

export const getClientTypeOptions = () => ["", "CHANNEL", "CLIENT"];
